import { renderGFM } from '~/behaviors/markdown/render_gfm';

renderGFM(document.getElementById('js-custom-sign-in-description'));
